exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".awarded-quotas-card{background:#fff;border-radius:8px;padding:8px}.awarded-quotas-card h6{font-size:16px;font-weight:700;margin:0 0 6px}.awarded-quotas-card p.subtitle{color:#666;line-height:normal;margin-bottom:12px}.awarded-quotas-card .awarded-quotas-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(100px,1fr));gap:4px}.awarded-quotas-card .awarded-quotas-grid .awarded-item{background:#f2f2f2;border-radius:6px;font-size:16px;padding:6px 0;text-align:center;font-weight:700}@media screen and (min-width:768px){.awarded-quotas-card .awarded-quotas-grid .awarded-item{font-size:20px;font-weight:700}}.awarded-quotas-card .awarded-quotas-grid .awarded-item.unavailable{background:#fbe9eb;text-decoration:line-through;color:#d92635}.awarded-quotas-card .awarded-expand-toggler{cursor:pointer;width:100%;text-align:center;font-weight:700;font-size:14px;line-height:24px;margin-top:8px}.redText{color:#d92635}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/rifa/styles/components/awardedQuotas.module.scss
// module id = 997
// module chunks = 0